export const COLORS = ['#ffffff', '#ffdd00', '#e03030', '#30b050', '#3080e0', '#000000'];
export const WIDTHS = [6, 12, 24];
